import React from "react";

import twMerge from "@replo/design-system/utils/twMerge";

const SettingsCard: React.FC<
  React.PropsWithChildren<{
    className?: string;
    title?: string;
    description?: string;
    actions?: React.ReactNode;
  }>
> = ({ children, className, title, description, actions }) => {
  return (
    <div
      className={twMerge(
        "flex flex-col items-start rounded-xl border-border bg-sheet border-0.5 p-5 shadow-selectable bg-white h-fit  gap-4",
        className,
      )}
    >
      <div className="flex w-full items-center justify-between">
        {(title ?? description) && (
          <div className="flex flex-col items-start">
            {title && <p className="header-h3">{title}</p>}
            {description && <p className="text-sm text-muted">{description}</p>}
          </div>
        )}
        {actions && <div className="ml-auto">{actions}</div>}
      </div>
      {children}
    </div>
  );
};

export default SettingsCard;
